import {MapTool} from '@apps-common/ui-maps';
import {array, func, object} from 'prop-types';
import React, {useCallback, useState} from 'react';

import DrawTools from './DrawTools/index.jsx';
import {measureTooltipMap} from './DrawTools/tooltips.js';
import {MAP_DRAW_LAYERS, MAP_TOOLS} from '@app/constants';
import {RulerIcon} from '@components/Viewer/Map/RulerIcon';

const MeasureToolMenuButton = ({
  tempGeometry,
  setTempGeometry,
  features,
  setFeatures,
  onHover,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  const deleteMeasureFeature = useCallback(
    feature => {
      setFeatures(features.filter(f => f.id !== feature.id));
    },
    [features, setFeatures]
  );

  const changeMeasureFeatureVisibility = useCallback(
    feature => {
      setFeatures(
        features.map(f => {
          if (f.id === feature.id) {
            const fprops = f.properties || {};

            f.properties = {
              ...fprops,
              visible: !(
                fprops.visible === undefined || fprops.visible === true
              ),
            };
          }
          return f;
        })
      );
    },
    [features, setFeatures]
  );

  const onSave = useCallback(
    feature => {
      if (tempGeometry) {
        for (let i = 0, ii = features.length; i < ii; i++) {
          if (features[i].id === feature.id) {
            features[i] = {
              ...feature,
              geometry: tempGeometry,
            };
          }
        }
        setFeatures(features);
      }
    },
    [features, setFeatures, tempGeometry]
  );

  return (
    <>
      <MapTool
        value="measure-tool"
        tooltipTitle="Measure areas and distances"
        tooltipPosition="left-end"
        active={isOpen}
        icon={<RulerIcon />}
        onClick={event => {
          setAnchorEl(anchorEl ? null : event.currentTarget);
        }}
        {...props}
      />

      <DrawTools
        anchorEl={anchorEl}
        open={isOpen}
        tempGeometry={tempGeometry}
        setTempGeometry={setTempGeometry}
        features={features}
        setFeatures={setFeatures}
        placement="top-end"
        drawLayer={MAP_DRAW_LAYERS.MEASURE}
        title="Measure"
        toolsAvailable={[MAP_TOOLS.DRAW_POLYGON, MAP_TOOLS.DRAW_LINE]}
        tooltips={measureTooltipMap}
        onDelete={deleteMeasureFeature}
        onChangeVisibility={changeMeasureFeatureVisibility}
        onHover={onHover}
        onSave={onSave}
      />
    </>
  );
};

MeasureToolMenuButton.propTypes = {
  tempGeometry: object,
  setTempGeometry: func,
  features: array,
  setFeatures: func,
  onHover: func,
};

export default MeasureToolMenuButton;
